import PropTypes from 'prop-types';
import { PERMISSION } from '../constants/permissions.const';

// @Note defined properly in IPermission
export const PERMISSION_PROP_TYPES = {
  name: PropTypes.oneOf(Object.values(PERMISSION)).isRequired,
  readableName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
